import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/suggestion.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, ArticleSuggestionApprovedAndMergedEvent, ActivityEventTrackMode } from './Types'
import { Link } from 'react-router-dom'
import { stopPropagation } from 'utils'

interface Props extends ActivityEventPosition {
  event: ArticleSuggestionApprovedAndMergedEvent
}

const ArticleSuggestionApprovedAndMerged = ({ event, ...props }: Props) => {
  const {
    user,
    article,
    data: { branch, base_branch, message, suggester },
  } = event
  const isBaseBranch = base_branch.key === article.key

  const content = isBaseBranch ? (
    <>
      <Actor displayName={user.display_name || 'Anonymous user'} userId={user?.id} /> approved and merged{' '}
      <Actor displayName={suggester.display_name || 'Anonymous user'} userId={suggester?.id} />
      's changes from this linked copy:{' '}
      <Link to={branch.url} onClick={stopPropagation}>
        {branch.title}
      </Link>
    </>
  ) : (
    <>
      <Actor displayName={user.display_name || 'Anonymous user'} userId={user?.id} /> approved and merged{' '}
      <Actor displayName={suggester.display_name || 'Anonymous user'} userId={suggester?.id} />
      's changes on this linked copy
    </>
  )

  return (
    <BaseActivityEvent
      {...props}
      trackMode={ActivityEventTrackMode.Merge}
      icon={<Icon />}
      timestamp={event.timestamp}
      content={content}
      message={message}
    />
  )
}

export { ArticleSuggestionApprovedAndMerged }
